import { render } from "./setup-user.vue?vue&type=template&id=b6731a16"
import script from "./setup-user.vue?vue&type=script&lang=js"
export * from "./setup-user.vue?vue&type=script&lang=js"

import "./setup-user.vue?vue&type=style&index=0&id=b6731a16&lang=css"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__